"use client";
import { useState } from "react";
import { useSocket } from "@/hooks/useSocket";
import { useInboxChannel } from "@/hooks/useInboxChannel";
import useAuthStore from "@auth/store/useAuthStore";
import ScrollBtn from "@components/ScrollBtn";
import { logout } from "@auth/api/authApi";
import { TwilioProvider } from "@/app/_providers/TwilioProvider";
import ModalError from "@components/modals/ModalError";

export function AppShell({ children }) {
  const {
    user,
    showSessionExpiredModal,
    setShowSessionExpiredModal,
    clearAuthData,
  } = useAuthStore();

  const socket = useSocket(user?.id, user?.supplier_uuid);

  const [tokenTwilio, setTokenTwilio] = useState("");

  useInboxChannel(
    socket,
    user?.supplier_uuid ?? "",
    // ... callbacks — ideally refactor useInboxChannel
    // to accept one object instead of 20 positional arguments

    () => {},   // setQrCode
    () => {},   // setContacts
    () => {},   // setIsQRVisible
    () => {},   // setMessages
    () => {},   // setSelectedContact
    "",         // selectedContact
    () => {},   // setSelectedName
    () => {},   // setIsLoading
    "",         // messageContent
    () => {},   // setMessageContent
    () => {},   // updateMessages
    null,       // ticket
    () => {},   // setIsLoadingMessages
    [],         // contactsClosed
    () => {},   // setContactsClosed
    [],         // contactsSnoozed
    () => {},   // setContactsSnoozed
    () => {},   // setUsersLive
    setTokenTwilio,
    () => {},   // setSearchResults
    () => {},   // setIsLoadingSearch
    null,       // suffix
    () => {},   // setShowButtonQR
    user?.id,
  );

  return (
    <>
      {children}
      <TwilioProvider tokenTwilio={tokenTwilio} />
      {showSessionExpiredModal && (
        <ModalError
          isvisible={showSessionExpiredModal}
          title="Session expired"
          message="You have been logged out. Please log in again."
          error=""
          errorList={[]}
          setIsSelectDisabled={() => {}}
          indexSelect={0}
          selectRefs={null}
          isEditTable={false}
          onClose={() => {
            logout(clearAuthData);
            setShowSessionExpiredModal(false);
          }}
          buttonLogout={true}
        />
      )}
      <ScrollBtn />
    </>
  );
}
